import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_URL, phoneNumber } from '../../common/constant';
import BottomNav from '../../component/BottomNav';
import Loader from '../../component/loader/Loader';
import FAQ from '../../component/FAQ/FAQ';
import { Helmet } from 'react-helmet';

const AllBlogs = () => {
    const navigate = useNavigate();
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {

        window.scrollTo(0, 0)
        const fetchBlogs = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/blog/blogs`);
                setBlogs(response.data.blogs);
            } catch (err) {
                setError("Failed to load blogs. Please try again later.");
            } finally {
                setLoading(false);
            }
        };
        fetchBlogs();
    }, []);

    const handleReadMore = (slug) => {
        navigate(`/blog/${slug}`);
    };


    const list_property = () => {
        navigate("/list-Property")
    }

    return (
        <>
            <Helmet>
                <title>Latest Real Estate Blogs & Articles - Placezio Estate</title>
                <meta name="description" content="Read the latest real estate blogs and property articles on Placezio Estate. Stay updated with market trends, investment tips, and property insights." />
                <meta name="keywords" content="real estate blogs, property articles, home buying tips, rental advice, Placezio Estate blogs" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Latest Real Estate Blogs & Articles - Placezio Estate" />
                <meta property="og:description" content="Stay updated with the latest real estate trends, property investment tips, and home buying guides on Placezio Estate." />
            </Helmet>

            <div className=" mx-10 p-2">
                <h1 className='py-4 text-[#54BD95] text-4xl  border-l-8 border-[#54BD95] pl-4'>
                    Latest Blogs and Articles
                </h1>

                <div className="grid md:grid-cols-4  gap-8 mt-6">
                    {loading ? (
                        <Loader />
                    ) : error ? (
                        <p className="text-red-500">{error}</p>
                    ) : (
                        blogs.map((blog) => (
                            <div
                                key={blog._id}
                                onClick={() => handleReadMore(blog.slug)}
                                className="bg-white shadow rounded-lg overflow-hidden transition-all hover:shadow-xl hover:scale-[1.02] cursor-pointer"
                            >
                                <div className="relative">
                                    <img
                                        src={`${API_URL}/uploads/blogs/${blog._id}/${blog.featureImages[0]}`}
                                        alt={blog.title}
                                        className="h-60 w-full object-cover"
                                    />
                                    <div className="absolute inset-0 bg-black bg-opacity-30"></div>
                                </div>
                                <div className="p-6">
                                    <h2 className="text-xl font-semibold mb-2 text-gray-900 hover:text-[#54BD95] transition-all duration-300">
                                        {blog.title}
                                    </h2>
                                    {/* <div
                                    className="text-gray-600 text-sm mb-4 line-clamp-3"
                                    dangerouslySetInnerHTML={{
                                        __html: blog.content.length > 100
                                            ? blog.content.substring(0, 100) + "..."
                                            : blog.content
                                    }}
                                /> */}

                                    <p
                                        onClick={() => handleReadMore(blog.slug)}
                                        className="w-full text-[#59bd95] text-white px-4 py-2 rounded-md hover:bg-[#3e9e76] transition-colors duration-300"
                                    >
                                        {' Read Full Blog---->'}
                                    </p>

                                    <p className="text-gray-500 text-sm mt-2">Added on: {new Date(blog.createdAt).toLocaleDateString()}  <p className='text-[#59bd95]'> By Placezio Estate</p></p>
                                </div>
                            </div>
                        ))
                    )}
                </div>
                <div className="mt-12">
                    <div
                        className="flex bg-[#54BD95] lg:p-2 lg:mx-24 mt-12 justify-between items-center"
                        style={{
                            height: "100%",
                            boxShadow: "0px 4px 15px rgba(141, 231, 177, 0.9)" // Add black shadow
                        }}
                    >
                        <div className="px-4">
                            <h2 className="text-white" style={{ fontSize: "30px" }}>List Your Property</h2>
                            <p className="font-bold text-white text-lg">Free Property Listing on Placezio Estate</p>
                        </div>
                        <div>
                            <button
                                className="bg-white text-[#54BD95] px-3 mx-2 py-2 rounded hover:bg-[#45a68b] hover:text-white"
                                onClick={list_property}
                            >
                                List your Property
                            </button>
                        </div>
                    </div>
                </div>
                <div className='mt-8'>
                    <FAQ />
                </div>
            </div>
            <BottomNav />

        </>
    );
};

export default AllBlogs;
